import { render, staticRenderFns } from "./DumbappBlocks.vue?vue&type=template&id=ae4e5a6c&scoped=true&"
import script from "./DumbappBlocks.vue?vue&type=script&lang=ts&"
export * from "./DumbappBlocks.vue?vue&type=script&lang=ts&"
import style0 from "./DumbappBlocks.vue?vue&type=style&index=0&id=ae4e5a6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4e5a6c",
  null
  
)

export default component.exports